module.exports = __webpack_public_path__ + "4d87523529fa55e6e2a76744d5b493c1.svg";